// Axios global configuration
// This file MUST be imported before any other component that uses axios
import axios from 'axios';

// Configure axios to send cookies with ALL requests
axios.defaults.withCredentials = true;

// Set default timeout
axios.defaults.timeout = 30000;

// Export configured axios instance
export default axios;
